define([
  'react',
  'prop-types',
  'js-cookie',
], (React, PropTypes, jscookie) => {
  class Hidden extends React.Component {
    static propTypes = {
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      value: PropTypes.string,
    };

    constructor(props) {
      super(props);
      const { name, value, onChangeForm } = props;

      if (onChangeForm) onChangeForm({ [name]: this.transformFieldValue(value) });
    }

    transformFieldValue(value) {
      // for hidden fields replace {cookie_XXX} variables with site client cookies
      return value.replace(/{cookie_(.*)}/g, (re, token) => {
        const cookieValue = jscookie.get(token);

        return cookieValue || '';
      });
    }

    render() {
      const { name, value } = this.props;

      return <input type="hidden" name={name} value={this.transformFieldValue(value)} />;
    }
  }

  return Hidden;
});
